import React, { useEffect } from 'react';
import './giftsOrders.css';
import { useDispatch, useSelector } from "react-redux";
import {  } from "../../redux/sagaActions";
import Pagination from "../../components/Pagination/Pagination";
import { getGiftsOrdersSagaAction } from "../../redux/sagaActions";
import { actionGiftOrderSagaAction } from "../../redux/sagaActions";

const statuses = {
    pending: 'Ожидает подтверждения',
    accepted: 'Выполнен',
    rejected: 'Отклонён'
};

const GiftsOrders = () => {
    const dispatch = useDispatch();

    const giftsOrders = useSelector(state => state.giftsOrders);
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const giftsStatusFilterOptions = useSelector(state => state.giftsStatusFilterOptions);
    const filterUser = useSelector(state => state.filterUser);

    // Функция смены страницы
    const changePage = page => {
        dispatch(getGiftsOrdersSagaAction({
            establishment: currentEstablishment,
            page,
            user: filterUser.user.id,
            status: JSON.stringify(giftsStatusFilterOptions.filter(el => el.active).map(el => el.id))
        }));
    };

    // Получение списка заказанных бонусов
    useEffect(() => {
        if (!currentEstablishment) return;

        dispatch(getGiftsOrdersSagaAction({
            establishment: currentEstablishment,
            page: 1,
            user: filterUser.user.id,
            status: JSON.stringify(giftsStatusFilterOptions.filter(el => el.active).map(el => el.id))
        }));
    }, [currentEstablishment]);

    return (
        <>
            <div className="page__content">
                <div className="table__header">
                    <div className="table__caption">Список бонусов</div>
                </div>
                <div className="table">
                    <div className="table__row table__row--header giftsorders__table">
                        <div className="table__cell table__cell--left">Посетитель</div>
                        <div className="table__cell">Телефон</div>
                        <div className="table__cell">Название бонуса</div>
                        <div className="table__cell">Дата и время заказа</div>
                        <div className="table__cell">Статус</div>
                        <div className="table__cell"/>
                        <div className="table__cell"/>
                    </div>
                    {
                        giftsOrders.map(elem => {
                            return (
                                <div className="table__row giftsorders__table" key={ elem.id }>
                                    <div className="table__cell table__cell--left">{ elem.user_name }</div>
                                    <div className="table__cell">{ elem.user_phone }</div>
                                    <div className="table__cell">{ elem.gift_name }</div>
                                    <div className="table__cell">{ elem.datetime }</div>
                                    <div className={ `table__cell giftsorders--${ elem.status }` }>{ statuses[elem.status] }</div>
                                    <div
                                        className="table__cell giftsorders__action"
                                        onClick={ () => dispatch(actionGiftOrderSagaAction({
                                            gift_order_id: elem.id,
                                            action_type: 'accepted'
                                        })) }
                                    >{ elem.status === 'pending' ? 'Подтвердить' : '' }</div>
                                    <div
                                        className="table__cell giftsorders__action"
                                        onClick={ () => dispatch(actionGiftOrderSagaAction({
                                            gift_order_id: elem.id,
                                            action_type: 'rejected'
                                        })) }
                                    >{ elem.status === 'pending' ? 'Отклонить' : '' }</div>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
            <Pagination handler={ changePage }/>
        </>
    );
};

export default GiftsOrders;